
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { Product } from '@/types/product';

@Component
export default class ProductMetaDataInput extends Vue {
  @Prop() product!: Product;

  @Mutation('products/setProductMetaTitle') setProductMetaTitle!: Function;
  @Mutation('products/setProductMetaDescription')
  setProductMetaDescription!: Function;
  @Mutation('products/setProductCanonicalUrl')
  setProductCanonicalUrl!: Function;
  @Mutation('products/setProductTwitterTitle')
  setProductTwitterTitle!: Function;
  @Mutation('products/setProductTwitterDescription')
  setProductTwitterDescription!: Function;
  @Mutation('products/setProductOpenGraphTitle')
  setProductOpenGraphTitle!: Function;
  @Mutation('products/setProductOpenGraphDescription')
  setProductOpenGraphDescription!: Function;

  get noindex() {
    return this.product.content.meta!.noindex;
  }
  set noindex(value) {
    this.product.content.meta!.noindex = value;
  }
  get meta_title() {
    return this.product.content.meta!.meta_title;
  }
  set meta_title(value) {
    this.setProductMetaTitle(value);
  }
  get meta_description() {
    return this.product.content.meta!.meta_description;
  }
  set meta_description(value) {
    this.setProductMetaDescription(value);
  }
  get canonical_url() {
    return this.product.content.meta!.canonical_url;
  }
  set canonical_url(value) {
    this.setProductCanonicalUrl(value);
  }

  get twitter_title() {
    return this.product.content.meta!.twitter_title;
  }
  set twitter_title(value) {
    this.setProductTwitterTitle(value);
  }
  get twitter_description() {
    return this.product.content.meta!.twitter_description;
  }
  set twitter_description(value) {
    this.setProductTwitterDescription(value);
  }

  get open_graph_title() {
    return this.product.content.meta!.open_graph_title;
  }
  set open_graph_title(value) {
    this.setProductOpenGraphTitle(value);
  }
  get open_graph_description() {
    return this.product.content.meta!.open_graph_description;
  }
  set open_graph_description(value) {
    this.setProductOpenGraphDescription(value);
  }
}
